export default __webpack_public_path__ + "static/media/pantry1-afterG-480w.11a20346.webp";